import { render, staticRenderFns } from "./Description.vue?vue&type=template&id=9e19c8cc&scoped=true"
import script from "./Description.vue?vue&type=script&lang=js"
export * from "./Description.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e19c8cc",
  null
  
)

export default component.exports